import { useState } from "react";
import { Reveal, stagger, item } from "./motion";
import { motion } from "framer-motion";
import { REVIEWS } from "@/data";
import { Star, Quote, BadgeCheck, X } from "lucide-react";
import { Dialog, DialogContent } from "@/components/ui/dialog";

const Stars = ({ n }) => (
  <div className="flex gap-0.5" aria-label={`${n} stars`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} size={16} className={i <= n ? "fill-[#E8A87C] text-[#E8A87C]" : "text-black/15"} />
    ))}
  </div>
);

export const Testimonials = () => {
  const [zoom, setZoom] = useState(null);

  return (
    <section id="reviews" className="py-24 sm:py-32 scroll-mt-24" data-testid="reviews">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <div>
              <p className="overline text-[#B9735A] mb-5">Patient Voices</p>
              <h2 className="font-serif-display font-light text-4xl sm:text-6xl text-[#1A1C1A] tracking-tight max-w-2xl">
                Care that leaves a <span className="italic text-[#B9735A]">human touch</span>
              </h2>
            </div>
            <div className="flex items-center gap-2 text-[#6B7A6A]">
              <BadgeCheck size={18} className="text-[#6B7A6A]" />
              <span className="text-sm">Verified reviews from Google &amp; SPARSH Hospital</span>
            </div>
          </div>
        </Reveal>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-12 grid md:grid-cols-3 gap-5"
        >
          {REVIEWS.map((r, i) => (
            <motion.div
              key={r.name}
              variants={item}
              className="rounded-3xl bg-white border border-black/5 p-7 flex flex-col hover:-translate-y-1 hover:shadow-xl transition-[transform,box-shadow] duration-300"
              data-testid={`review-${i}`}
            >
              <Quote className="text-[#B9735A]/30" size={30} />
              <p className="mt-4 text-[#4A4D4A] leading-relaxed text-sm flex-1">{r.text}</p>
              <div className="mt-6 pt-5 border-t border-black/5">
                <Stars n={r.rating} />
                <div className="mt-3 flex items-center justify-between gap-3">
                  <div>
                    <p className="text-[#1A1C1A] font-medium">{r.name}</p>
                    <p className="text-xs text-[#6B7A6A]">{r.source} · {r.when}</p>
                  </div>
                  <button
                    onClick={() => setZoom(r.image)}
                    className="text-xs font-semibold text-[#B9735A] hover:underline shrink-0"
                    data-testid={`review-view-${i}`}
                  >
                    View proof
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>

      <Dialog open={!!zoom} onOpenChange={(o) => !o && setZoom(null)}>
        <DialogContent className="max-w-sm bg-[#FDFBF7] p-3 border-black/5" data-testid="review-image-dialog">
          {zoom && <img src={zoom} alt="Google review screenshot" className="w-full rounded-xl" />}
        </DialogContent>
      </Dialog>
    </section>
  );
};
